import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { StyledButton } from '../../../../components/StyledButton';
import StyledCardComprovante from '../../../../components/StyledCardComprovante';
import { PrintComponent } from '../../../../services/PrintComponent';
import { useComprovante } from '../../../../services/hooks/useComprovante';
import { ContentBody, ContentHeader, Loading } from './styles';

interface ComprovanteModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  docto: string;
  id: string;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',

    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export function ComprovanteModal({
  isOpen,
  onRequestClose,
  docto,
  id,
}: ComprovanteModalProps) {
  const [print, setPrint] = useState(false);

  const { data, isLoading, error } = useComprovante({ docto, id });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Example Modal"
      style={customStyles}
    >
      <ContentHeader>
        <StyledButton
          text="Imprimir"
          icon={<Icon icon="material-symbols:print" />}
          iconPosition="left"
          onClick={() => setPrint(true)}
          // disabled={isLoading || isFetching}
        />
        <StyledButton
          text="Fechar"
          icon={<Icon icon="material-symbols:close" />}
          color="#595044"
          iconPosition="left"
          onClick={() => onRequestClose()}
        />
      </ContentHeader>

      <ContentBody>
        {isLoading ? (
          <Loading>Carregando...</Loading>
        ) : error ? (
          <Loading>Erro ao carregar dados</Loading>
        ) : (
          <PrintComponent onPrint={print} setOnPrint={setPrint}>
            <StyledCardComprovante
              sacadoBanco={data?.sacadoBanco ?? ''}
              sacadoAgencia={data?.sacadoAgencia ?? ''}
              sacadoConta={data?.sacadoConta ?? ''}
              dtTransacao={data?.dtTransacao ?? ''}
              vlMovimento={data?.vlMovimento ?? 0}
              meioPagamento={data?.meioPagamento ?? ''}
              autenticacao={data?.autenticacao ?? ''}
              favDocto={data?.favDocto ?? ''}
              favNome={data?.favNome ?? ''}
              favBanco={data?.favBanco ?? ''}
              favBancoNome={data?.favBancoNome ?? ''}
              favTipoConta={data?.favTipoConta ?? ''}
              favAgencia={data?.favAgencia ?? ''}
              favConta={data?.favConta ?? ''}
            />
          </PrintComponent>
        )}
      </ContentBody>
    </Modal>
  );
}
